module.exports = __webpack_public_path__ + "img/banner_coun_guide_02.dba66f58.png";